
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuthReadiness } from '@/hooks/useAuthReadiness';

export interface Order {
  id: string;
  order_number: string;
  total_amount: number;
  status: string;
  created_at: string;
}

const fetchRecentOrders = async (userId: string, limit: number = 3) => {
  const { data, error } = await supabase
    .from('orders')
    .select('id, order_number, total_amount, status, created_at')
    .eq('user_id', userId)
    .order('created_at', { ascending: false })
    .limit(limit);

  if (error) {
    console.error('Error fetching recent orders:', error);
    throw error;
  }
  
  return data as Order[];
};

export const useRecentOrders = (limit: number = 3) => {
  const { user, canQueryUserData } = useAuthReadiness();
  const userId = user?.id;

  const { data: recentOrders, isLoading } = useQuery({
    queryKey: ['recent-orders', userId, limit],
    queryFn: () => fetchRecentOrders(userId!, limit),
    enabled: canQueryUserData,
  });

  return {
    recentOrders: recentOrders ?? [],
    isLoading,
  };
};
